import React, { Component } from 'react';
import TableModal from '../../../../../Components/UI/TableModal';
import { isSet,getSelectedValueBasedOnField,isObject } from '../../../../../Utils/CommonFunctions';
import { getFieldPropertiesFromGridList } from '../../../../../Containers/LayoutContainer/LayoutCommonFunction';
// import {callPOST} from '../../../../../Utils/ApiUtil';
import http from '../../../../../services/http';
import { withRouter } from 'react-router';
import Wrp from '../../../../../hoc/Wrp/Wrp';
import { connect } from 'react-redux';
import * as actions from '../../../../../store/actions';
import QuickCreateForms from '../../../../../Containers/LayoutContainer/QuickCreateForms';

class LookupModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
        isModalOpen:this.props.isModalOpen,
        isQuickAddModalOpen:this.props.isQuickAddModalOpen,
        status:null,
        lookup_layout:this.props.lookup_layout,
        page:this.props.page,
        isConfirmPage:false,
        tableRecords:{
          tableHead:[],
          tableData:[], 
          pagination:{
            page:0,
            orderBy:'',
            perPage:10,
            direction:'ASC',
            totalRecords:0,
            search:''
          }
        },
        selectedValueCustom: this.props.selectedValue
    }
  }
  // componentWillMount = ()=>{
    // this.LayoutsFormsList(this.state.tableRecords.pagination);
  // } 
    componentDidUpdate = (prevProps) => {
      //console.log('componentDidUpdate==')
      if(prevProps.isModalOpen !== this.props.isModalOpen) {
        this.setState({isModalOpen: this.props.isModalOpen});
        if(this.props.isModalOpen===true && this.state.isQuickAddModalOpen===false){
          this.LayoutsFormsList(this.state.tableRecords.pagination,true);
        }
      }else if(prevProps.isQuickAddModalOpen !== this.props.isQuickAddModalOpen){
        this.setState({isQuickAddModalOpen: this.props.isQuickAddModalOpen,lookup_layout:this.props.lookup_layout});
      }
    }
    componentDidCatch(error, errorInfo) {
      console.log('componentDidCatch(error, errorInfo) ....');
    }
    
    onChangeSelectLookup = (rowId,wthis)=>{
      //console.log('onChangeSelectLookup')
      const tableDataSel = this.state.tableRecords;
      tableDataSel.tableData.data.map((item,index)=>{
        if(item.rowId===rowId){
          tableDataSel.tableData.data[index].className='selected';
          tableDataSel.tableData.data[index].data.RadioButton.checked=true;
          let displayName = [];
          let defaultDisplay = [];
          tableDataSel.tableHead.forEach((columnData,columnIndex)=>{
            const colId = tableDataSel.tableHead[columnIndex].columnId;
            if(tableDataSel.tableData.data[index].data[colId]){
              const selectedItem = tableDataSel.tableData.data[index].data[colId];
              const selectedValue = selectedItem.value;
              if(selectedValue!=='' && selectedValue!==undefined && selectedValue!==null){
                displayName.push(selectedValue);
                if(selectedItem.isDefaultDisplay===true && defaultDisplay.length<2){
                  defaultDisplay.push(selectedValue);
                }
              }
            }
          })
          const endPos = (tableDataSel.tableHead.length<=2)? tableDataSel.tableHead.length:2;
          displayName = (defaultDisplay.length===0)?displayName.slice(0,endPos):defaultDisplay;
        }else{
          tableDataSel.tableData.data[index].className='';
          tableDataSel.tableData.data[index].data.RadioButton.checked=false;
        }
      })
      this.setState({tableRecords:{
        ...tableDataSel
      }, selectedValueCustom: rowId})
    }

  
  //MODAL POPUP - CONFIRM
  confirmLoopupModalHandler = () =>{
    //this.setState({isModalOpen: false});
    //console.log('onChangeSelectLookup')
      let rowId = this.state.selectedValueCustom;
      const tableDataSel = this.state.tableRecords;
      tableDataSel.tableData.data.map((item,index)=>{
        if(item.rowId===rowId){
          tableDataSel.tableData.data[index].className='selected';
          tableDataSel.tableData.data[index].data.RadioButton.checked=true;
          let displayName = [];
          let defaultDisplay = [];
          tableDataSel.tableHead.forEach((columnData,columnIndex)=>{
            const colId = tableDataSel.tableHead[columnIndex].columnId;
            if(tableDataSel.tableData.data[index].data[colId]){
              const selectedItem = tableDataSel.tableData.data[index].data[colId];
              const selectedValue = selectedItem.value;
              if(isObject(selectedValue)===true){return false;}
              if(selectedValue!=='' && selectedValue!==undefined && selectedValue!==null){
                displayName.push(selectedValue);
                if(selectedItem.isDefaultDisplay===true && defaultDisplay.length<2){
                  defaultDisplay.push(selectedValue);
                }
              }
            }
          })
          const endPos = (tableDataSel.tableHead.length<=2)? tableDataSel.tableHead.length:2;
          displayName = (defaultDisplay.length===0)?displayName.slice(0,endPos):defaultDisplay;
          this.props.setLookupValuesFromList({
            label:displayName.join(' '),
            value:rowId,
            fields:item.data,
            ruleMapping:item.ruleMapping
          });
        }else{
          tableDataSel.tableData.data[index].className='';
          tableDataSel.tableData.data[index].data.RadioButton.checked=false;
        }
      })
      this.setState({tableRecords:{
        ...tableDataSel
      }})
    this.props.cancelLoopupModalHandler()
  }

 //MODAL POPUP 
  openQuickCreatePopup = () =>{
    this.setState({isQuickAddModalOpen:true});
  }
  //MODAL POPUP - CANCEL
  closeQuickCreatePopup = () =>{
    this.setState({isQuickAddModalOpen: false});
    this.props.closeQuickCreatePopupFromSugg();
  }    
 recordsChangeHandler = (pagination)=>{
    this.LayoutsFormsList(pagination)
 }  
 goBackLookupList =()=>{
   this.LayoutsFormsList(this.state.tableRecords.pagination,true);
 }
 
  LayoutsFormsList =(pagination,loader=false) =>{
    // my code 07 - Avoid subform exception
    const {item} = this.props;
    if(item.is_subform===true){ return false; }
    // endss 

    const windowName = this.props.windowName;
    const params = this.props.match.params;
    const page = pagination.page; 
    const orderBy = pagination.orderBy; 
    const perPage = pagination.perPage; 
    const direction = pagination.direction; 
    const search = pagination.search;
    this.setState({
      tableRecords:{
        ...this.state.tableRecords,
        pagination:pagination
      }
    })
    if(loader===true){ this.props.Loader(); }
    const queryString = '?query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction+'&parent_layout_id='+params.layoutId+'&parent_window_id='+params.windowId;
    // this.LayoutsFormsListCountAPI(windowName,queryString)
    const listDataPromise  = http.POST('table-data-engine/'+windowName+'/metatable/record-list/active'+queryString,{});
    const listCountPromise  = http.POST('table-data-engine/'+windowName+'/metatable/record-listCount/active'+queryString,{});
    Promise.all([listCountPromise, listDataPromise])
    .then(([resCount, res]) => {
      if(loader===true){ this.props.Loader(); }
      if(res.status===200){ 
        const response = res.data;
        const responseCount = resCount.data;
        if(response.code===200){
          const resData = response.data;
          let gridList = response.data.grid_list;
          const layout_rule_map = isSet(response.data.layout_rule_map,{});
          const lookupData = isSet(response.data.lookup_data,{});
          this.setState({lookup_layout:{
            lookupLayoutId:resData.lookup_layout_id,
            moduleId:resData.module_id,
            windowId:resData.window_id,
            windowName:windowName,
          }, lookupData :lookupData});
          //  console.log('this.props',this.props);
          this.props.setLookupDataHandler(lookupData);
          let updateTableData = [];
          let fieldsRow;
          let tablehead = [
            {
              id:resData.window_id,
              type:"RadioButton",
              columnId:"",
              isShow:true,
              attributes:{style:{width: "30px"}}
            }
          ]
          response.data.grid_list.map((header)=>{
            tablehead.push({
              name:header.display_name,
              type:"HyperLink",
              columnId:header.table_descriptor_id,
              isShow:header.is_show,
            });
          }) 
          // console.log(tablehead);
          response.data.value_list.content.map((contentData,contentIndex)=>{
            fieldsRow = {}
            fieldsRow = {
                ...fieldsRow,
                RadioButton:{
                  checked:(this.props.selectedValue && this.props.selectedValue!=null && this.props.selectedValue===contentData.meta_table_id)? true:false,
                  name:'windowCheckbox'
                }
            }
            tablehead.map((column,headIndex)=>{
              if(headIndex>0){
                fieldsRow = {
                  ...fieldsRow,
                  [column.columnId]:{
                    className:'',
                    value:''
                  },
                } 
              }
            })
            contentData.fields.map((item,itemIndex)=>{
              tablehead = [...tablehead].map((column)=>{
                if(item.table_descriptor_id===column.columnId){
                  //column.type = (item.element_type!=='ImageUpload')?'HyperLink':'Image';
                  let dataType = '';
                  if(item.element_type === 'Barcode') {
                    dataType = 'Barcode';
                  }else if(item.element_type==='ImageUpload' && item.files.length===0) {
                    dataType = 'Image';
                  }else if(item.element_type==='CheckBoxes') {
                    dataType = 'Others';
                  }else if(item.element_type!=='ImageUpload') {
                    dataType = 'HyperLink';
                  }else {
                    dataType = 'Image';
                  }
                  column.type = dataType;
                }
                return column;
              });
              item.selectedValue = item.value;
              item.element = (item.element_type==='PickList' || item.element_type==='MultiSelect' || item.element_type==='FileUpload'  || (item.element_type==='ImageUpload' && item.files.length===0))?'TextInput':item.element_type;
              item.options = [];
              const selectedValue = getSelectedValueBasedOnField(item);
              const property  = getFieldPropertiesFromGridList(gridList,item.table_descriptor_id);
              if(selectedValue!=='' && selectedValue!==undefined && selectedValue!==null && selectedValue!=='-'){
                fieldsRow = {
                  ...fieldsRow,
                  [item.table_descriptor_id]:{
                        className:(itemIndex<=1)?'primary_color cursor-pointer':'cursor-pointer',
                        isDefaultDisplay:isSet(property.is_default_displayname,false),
                        value:selectedValue
                  }
                }
              }
          });
            if (params.page === "add" || (params.formId && params.formId !== contentData.record_id)) {
          updateTableData.push({
            clickHandler:this.onChangeSelectLookup.bind(this,contentData.meta_table_id),
            className:(this.props.selectedValue && this.props.selectedValue!=null && contentData.meta_table_id===this.props.selectedValue)? 'selected':'',
            rowId:contentData.meta_table_id,
            ruleMapping:isSet(layout_rule_map[contentData.meta_table_id],{}),
            data:fieldsRow
          })
        }
        })  
          // console.log(updateTableData);
          
          const totalRecords = responseCount.data.value_list.total_elements;
          this.setState({status:200, tableRecords:{
            tableData:{data:updateTableData,status:200},
            tableHead:tablehead,
            pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
          }});
        }else{
          const totalRecords = 0;//response.data.totalElements;
          this.setState({status:200, tableRecords:{
            tableData:{data:[],status:400},
            tableHead:this.state.tableRecords.tableHead ,
            pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
          }});
        }
      }
    }, (error) => {
      console.log(error);
      this.props.failMessage("Something went wrong...");
      this.props.Loader(false);

    })
  }


cancelLoopupModalHandler = () => {
  // let displayName = [];
  // let rowIds = [];
  // this.props.setLookupValuesFromList({
  //   label:displayName.join(' '),
  //   value:rowIds.join(','),
  //   fields:''
  // });
  this.props.cancelLoopupModalHandler() 
}

    
    render () {
        const ModalTitle ="Select "+this.props.windowName;
        const modalType = 'tableList';
        const modalButtonList = [
            {
              attributes:{
                className:"btn btn-cancel",
                "data-dismiss":"modal",
                "id":"closeAddNewRoleModal",
              },
              clickHandler:this.cancelLoopupModalHandler,
              name:"Cancel"
            },
            {
              clickHandler:this.openQuickCreatePopup,
              type:'add',
              attributes:{
                "className":"btn primary_bg cursor-pointer",
              },
              name:"Add "+this.props.windowName
            }
          ];
          const FooterButtonList = [
            {
              attributes:{
                className:"btn primary_bg cursor-pointer",
                "data-dismiss":"modal",
              },
              disabled:(this.state.selectedValueCustom!=='' && this.state.selectedValueCustom!==null)? false:true,
              clickHandler:this.confirmLoopupModalHandler,
              name:"Confirm"
            }
          ];
          // console.log(JSON.stringify(this.state.tableRecords));
        try{
          return (
            <Wrp>
            <TableModal 
              isModalOpen={this.state.isModalOpen}
              title={ModalTitle}
              modalType={modalType}
              buttonList={modalButtonList}
              tableRecords={this.state.tableRecords}
              FooterButtonList={FooterButtonList}
              recordsChangeHandler={this.LayoutsFormsList}
              // selectedLookupCount = {this.props.selectedLookupCount.length}
              isConfirmPage={this.state.isConfirmPage}
               />
               {(this.state.isQuickAddModalOpen===true)?
                <QuickCreateForms 
                  succMessage={this.props.succMessage}
                  failMessage={this.props.failMessage}  
                  Loader={this.props.Loader}
                  closeQuickCreatePopup={this.closeQuickCreatePopup}
                  isQuickAddModalOpen={this.state.isQuickAddModalOpen}
                  lookup_layout={this.state.lookup_layout}
                  goBackLookupList={this.goBackLookupList}
                />  
             :''} 
            </Wrp>
          )
        }catch(e){
          this.props.failMessage("Something went wrong...");
        }
        
    }
}


const mapDispatchToProps = dispatch => {
  return {
    Loader : (bool) => dispatch(actions.loader(bool)),
    succMessage : (msg) => dispatch(actions.succMessage(msg)),
    failMessage : (msg) => dispatch(actions.failMessage(msg))    
  };
}
export default
  connect(
    null, 
    mapDispatchToProps
  )(withRouter(LookupModal));
// export default LookupModal;